<template>
  <sdi-fatture-clienti />
</template>

<script>
import SdiFattureClienti from '@/components/ask/pages/SdiFattureClienti.vue'

export default {
  name: 'PageSdiFattureClienti',

  components:{
    SdiFattureClienti
  },

  data(){
    return {
    
    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods:{

  },
}
</script>

<style>

</style>
